import {CART_SOURCE_TYPES, EBOOK_CART_ICON, EBOOK_PAGE_URL, MOCK_PRICING_TIER_ID} from '../api-constants';

function createDateRange() {
  const startDate = new Date();
  const endDate = new Date();
  endDate.setFullYear(startDate.getFullYear() + 1);

  return {
    startDate: startDate.toISOString(),
    endDate: endDate.toISOString(),
  };
}

function createMockPricingTier(amount, vatAmount, qtyFrom = null, qtyTo = null) {
  return {
    _id: MOCK_PRICING_TIER_ID,
    amount,
    vatAmount,
    qtyFrom,
    qtyTo,
  };
}

function fromEbookSearchResultItem(ebook, options) {
  const {startDate, endDate} = createDateRange();
  return {
    termLicense: false,
    quantity: options.quantity,
    materialNumber: ebook.sku,
    price: ebook.price,
    productName: ebook.title,
    startDate,
    endDate,
    metadata: {
      eisbn: ebook.eisbn,
      productInfo: {
        productIcon: EBOOK_CART_ICON,
        pricingPageUrl: EBOOK_PAGE_URL,
      },
      pricing: {
        pricingTiers: [createMockPricingTier(ebook.price, ebook.price)],
      },
    },
  };
}

function fromProductPricingModel(productModel, options) {
  const activeProduct = productModel.products.find((p) => p.sku === productModel.activeSku);

  return {
    termLicense: false,
    quantity: options.quantity,
    materialNumber: productModel.activeSku,
    price: productModel.activePrice,
    productName: activeProduct.productTitle,
    metadata: {
      productInfo: {
        productIcon: productModel.icon,
        pricingPageUrl: globalThis.location.href,
      },
      pricing: {
        pricingTiers: [
          createMockPricingTier(activeProduct.__amount__, activeProduct.__vatAmount__, activeProduct.qtyFrom, activeProduct.qtyTo),
        ],
      },
    },
  };
}

export const mapLineItem = (source, options = {}) => {
  switch (options.sourceType) {
    case CART_SOURCE_TYPES.EBOOK_SEARCH_RESULT_ITEM:
      return fromEbookSearchResultItem(source, options);
    case CART_SOURCE_TYPES.PRODUCT_PRICING_MODEL:
      return fromProductPricingModel(source, options);
    default:
      return source;
  }
};
